import React, { useState } from 'react';
import { useFormik } from 'formik';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import validationSchema from './validationSchema';
import Checkbox from '@mui/material/Checkbox';
import FileUploadViewer from 'views/NotFoundCover/FileUploadViewer';
import uploadStudentDetailsService from 'views/NotFoundCover/uploadStudentDetailsService';
import uploadFileService from 'views/NotFoundCover/uploadFileService';

const FirstStep = ({ handleCurrentStep, initialState }) => {
  

  let isDisabled = true;

  const [fileUploadedTime, setFileUploadedTime] = useState(null);

  const onSubmit = () => {
    // localStorage.form1Values = JSON.stringify(formik.values);
    handleCurrentStep(2, formik.values);
    uploadStudentDetailsService(formik.values, '1');
    if (formik.values.photo) {
     uploadFileService('studentAadhaar', formik.values.photo);
    }
  };

  

  const formik = useFormik({
    initialValues: initialState,
    validationSchema: validationSchema,
    onSubmit,
  });

  if (
    formik &&
    Object.keys(formik.errors).length === 0 &&
    formik.values.dateOfBirth &&
    formik.values.fullName &&
    formik.values.birthPlace &&
    formik.values.aadhar &&
    formik.values.photo 
  ) {
    isDisabled = false;
  }

 
  const handleUpdateFileInfo = (file, fileName, imagePreviewUrl) => {
    formik.values.photo = file;
    formik.values.fileName = fileName;
    formik.values.imagePreviewUrl = imagePreviewUrl;
    setFileUploadedTime(new Date());
  };

  return (
    <Box>
      <div>
        <Grid container spacing={4}>
          <Grid item xs={10} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Name of the Student*
            </Typography>
            <TextField
              label="Enter Student Name"
              variant="outlined"
              name={'fullName'}
              fullWidth
              defaultValue={formik.values.fullName}
              onChange={formik.handleChange('fullName')}
              error={formik.touched.fullName || Boolean(formik.errors.fullName)}
              helperText={formik.touched.fullName || formik.errors.fullName}
            />
            As per official records
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Gender*
            </Typography>
            <TextField
              select
              label="Gender"
              variant="outlined"
              name={'gender'}
              fullWidth
              defaultValue={formik.values.gender}
              onChange={formik.handleChange('gender')}
              error={formik.touched.gender || Boolean(formik.errors.gender)}
              helperText={formik.touched.gender || formik.errors.gender}
            >
              {['Select Gender', 'Male', 'Female'].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Date of Birth*
            </Typography>
            <TextField
              label=" DD-MM-YYYY"
              variant="outlined"
              name={'dateOfBirth'}
              fullWidth
              defaultValue={formik.values.dateOfBirth}
              onChange={formik.handleChange('dateOfBirth')}
              error={
                formik.touched.dateOfBirth || Boolean(formik.errors.dateOfBirth)
              }
              helperText={
                formik.touched.dateOfBirth || formik.errors.dateOfBirth
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Class*
            </Typography>
            <TextField
              select
              label="Class"
              variant="outlined"
              name={'class'}
              fullWidth
              defaultValue={formik.values.class}
              onChange={formik.handleChange('class')}
              error={formik.touched.class || Boolean(formik.errors.class)}
              helperText={formik.touched.class || formik.errors.class}
            >
              {['Select Class', 'Pre-KG'].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Birth Place*
            </Typography>
            <TextField
              label=" Birth Place"
              variant="outlined"
              name={'birthPlace'}
              fullWidth
              defaultValue={formik.values.birthPlace}
              onChange={formik.handleChange('birthPlace')}
              error={
                formik.touched.birthPlace || Boolean(formik.errors.birthPlace)
              }
              helperText={formik.touched.birthPlace || formik.errors.birthPlace}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Nationality*
            </Typography>
            <TextField
              select
              label="Nationality"
              variant="outlined"
              name={'nationality'}
              fullWidth
              defaultValue={formik.values.nationality}
              onChange={formik.handleChange('nationality')}
              error={
                formik.touched.nationality || Boolean(formik.errors.nationality)
              }
              helperText={
                formik.touched.nationality || formik.errors.nationality
              }
            >
              {['Indian', 'American', 'British', 'Others'].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Religion*
            </Typography>
            <TextField
              select
              label="Religion"
              variant="outlined"
              name={'religion'}
              fullWidth
              defaultValue={formik.values.religion}
              onChange={formik.handleChange('religion')}
              error={formik.touched.religion || Boolean(formik.errors.religion)}
              helperText={formik.touched.religion || formik.errors.religion}
            >
              {[
                'Buddhist',
                'Christian',
                'Hindu',
                'Islam',
                'Jain',
                'Muslim',
                'Sikh',
                'Others',
              ].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Mother Tongue*
            </Typography>
            <TextField
              select
              label="Mother Tongue"
              variant="outlined"
              name={'motherTongue'}
              fullWidth
              defaultValue={formik.values.motherTongue}
              onChange={formik.handleChange('motherTongue')}
              error={
                formik.touched.motherTongue ||
                Boolean(formik.errors.motherTongue)
              }
              helperText={
                formik.touched.motherTongue || formik.errors.motherTongue
              }
            >
              {[
                'Assamese',
                'Bengali',
                'English',
                'Gujarathi',
                'Hindi',
                'Kannada',
                'Malayalam',
                'Marati',
                'Telugu',
                'Tamil',
                'Urdu',
                'Others',
              ].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6} sm={4}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 1 }}
              fontWeight={700}
            >
              Student Sibling
              <Checkbox
                color="primary"
                id="siblings"
                name="siblings"
                defaultChecked={formik.values.siblings}
                onChange={formik.handleChange}
              />
            </Typography>
            <TextField
              label="Enter name"
              variant="outlined"
              disabled={!formik.values.siblings}
              name={'sibling1Name'}
              fullWidth
              defaultValue={formik.values.sibling1Name}
              onChange={formik.handleChange('sibling1Name')}
            />
          </Grid>
          <Grid item xs={5} sm={4} style={{ marginTop: 50 }}>
          
            <TextField
              label="Class "
              variant="outlined"
              disabled={!formik.values.siblings}
              name={'sibling1Class'}
              fullWidth
              defaultValue={formik.values.sibling1Class}
              onChange={formik.handleChange('sibling1Class')}
            />
          </Grid>
          <Grid item xs={5} sm={4} style={{ marginTop: 50 }}>
          
            <TextField
              label="Section"
              variant="outlined"
              name={'sibling1Section'}
              disabled={!formik.values.siblings}
              fullWidth
              defaultValue={formik.values.sibling1Section}
              onChange={formik.handleChange('sibling1Section')}
            />
          </Grid>
          <Grid item xs={5} sm={4}>
            <TextField
              label="Enter name"
              variant="outlined"
              disabled={!formik.values.siblings}
              name={'sibling2Name'}
              fullWidth
              defaultValue={formik.values.sibling2Name}
              onChange={formik.handleChange('sibling2Name')}
            />
          </Grid>
          <Grid item xs={5} sm={4}>
            <TextField
              label="Class "
              variant="outlined"
              disabled={!formik.values.siblings}
              name={'sibling2Class'}
              fullWidth
              defaultValue={formik.values.sibling2Class}
              onChange={formik.handleChange('sibling2Class')}
            />
          </Grid>
          <Grid item xs={5} sm={4}>
            <TextField
              label="Section"
              variant="outlined"
              name={'sibling2Section'}
              disabled={!formik.values.siblings}
              fullWidth
              defaultValue={formik.values.sibling2Section}
              onChange={formik.handleChange('sibling2Section')}
            />
          </Grid>
    
          <Grid item xs={12}  sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Is your child physically challenged?
            </Typography >
            <TextField
            select
              label="Is your child physically challenged?"
              variant="outlined"
              name={'physical'}
              fullWidth
              defaultValue={formik.values.physical}
              onChange={formik.handleChange('physical')}
              error={
                formik.touched.physical ||
                Boolean(formik.errors.physical)
              }
              helperText={
                formik.touched.physical || formik.errors.physical
              }
            >
              {[
                'Yes',
                'No',
              ].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
              </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Child has any special need/learning challenges?
            </Typography>
            <TextField
            select
              label="Child has any special need/learning challenges?"
              variant="outlined"
              name={'option'}
              fullWidth
              defaultValue={formik.values.option}
              onChange={formik.handleChange('option')}
              error={
                formik.touched.option ||
                Boolean(formik.errors.option)
              }
              helperText={
                formik.touched.option || formik.errors.option
              }
            >
              {[
                'Yes',
                'No',
              ].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
              </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Aadhar Card No*
            </Typography>
            <TextField
              label="Enter Aadhar No"
              variant="outlined"
              name={'aadhar'}
              fullWidth
              defaultValue={formik.values.aadhar}
              onChange={formik.handleChange('aadhar')}
              error={formik.touched.aadhar || Boolean(formik.errors.aadhar)}
              helperText={formik.touched.aadhar || formik.errors.aadhar}
            />
            Ex: XXXX XXXX XXXX(only numeric)
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Mode of transport
            </Typography>
            <TextField
            select
              label=" Mode of transport"
              variant="outlined"
              name={'transport'}
              fullWidth
              defaultValue={formik.values.transport}
              onChange={formik.handleChange('transport')}
              error={
                formik.touched.transport ||
                Boolean(formik.errors.transport)
              }
              helperText={
                formik.touched.transport || formik.errors.transport
              }
            >
              {[
                'School Bus',
                'Private',
              ].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
              </TextField>
          </Grid>

          <Grid item xs={10}>
            <Typography
              variant={'subtitle2'}
              sx={{ marginBottom: 2 }}
              fontWeight={700}
            >
              Upload recent photograph of the student*
            </Typography>

            <FileUploadViewer
              file = {formik.values.photo}
              info={`stepone`}
              fileName={formik.values.fileName}
              imagePreviewUrl={formik.values.imagePreviewUrl}
              handleUpdateFileInfo={handleUpdateFileInfo} 
            />
          </Grid>

       

          <Box
            component={Button}
            variant="contained"
            color="primary"
            size="large"
            type={'submit'}
            height={54}
            marginTop={{ xs: 8, sm: 9 }}
            marginLeft={{ sm: 50 }}
            disabled={isDisabled}
            readOnly={isDisabled}
            onClick={onSubmit}
            //href="/career-listing-minimal"
          >
            Save and Continue
          </Box>
        </Grid>
      </div>
    </Box>
  );
};

export default FirstStep;
